import { useContext } from "react";
import KyoceraLogo from "../../assets/images/kyocera-logo.png";
import DevPortalLogo from "../../assets/images/provider-portal-logo-dark.png";
import { useTranslation } from "react-i18next";
import { USER_ROLES, BRAND_NAMES, DEVICE_FEATURE } from "../../utils/constants";
import { AppConfig } from "../../context/context";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import NavItemComponent from "./nav-item/nav-item";

import { styled } from "@mui/system";
import { Person, SupervisorAccount } from "@mui/icons-material";
 
const SideNavComponent = () => {
  const theme = useTheme();
  const { config, userProfile } = useContext(AppConfig) || {};

  if (!config || !userProfile) {
    throw new Error("AppConfig context is not properly initialized.");
  }
  
  const SideNav = styled("div")({
    backgroundColor: "var(--kyocera-cp-background-grey) !important",
    borderRadius: "0px 10px 10px 0px",
    display: "flex",
    flexDirection: "column",
    gridTemplateRows: "160px 65px auto",
    height: "100%",
    padding: theme.spacing(1.5),
    ".title": {
      gridRowStart: 1,
      gridRowEnd: 2,
      paddingTop: theme.spacing(2),

      "& .login-image": {
        width: "160px",
        padding: theme.spacing(2),
      },

      "& .login-image-text": {
        width: "200px",
        padding: theme.spacing(1),
      },

      "& h1": {
        fontSize: "1.8rem",
      },
    },
    ".menu": {
      gridRowStart: 2,
      gridRowEnd: 3,
      padding: theme.spacing(2),
    },
    ".menuItems": {
      gridRowStart: 2,
      gridRowEnd: 3,
      padding: theme.spacing(2),
    },
  });

  const { t } = useTranslation("common");

  return (
  
  <SideNav>
      <Box
        className="title"
        display="flex"
        justifyContent="start"
        flexDirection="column"
        alignItems="center"
      >
        <img
          className="login-image-text d-block"
          alt="Provider portal"
          src={DevPortalLogo}
        />
      </Box>
      <div className="menuItems">
      <NavItemComponent
            exact={true}
            to="/"
            title={t("Organizations")}
            > 
              <SupervisorAccount fontSize="small" />
            </NavItemComponent>

        {USER_ROLES.admins.includes(userProfile.role) && 
          <NavItemComponent
            exact={true}
            to="/users"
            title={t("Users")}
            > 
              <Person fontSize="small" />
            </NavItemComponent>
        }
       

        {/* <NavItemComponent
          exact={true}
          to="/about"
          title={t("AboutDevPortal")}
        > */}
          {/* <InfoRounded fontSize="small" /> */}
        {/* </NavItemComponent> */}
        { /* <NavItemComponent
          exact={true}
          to="/settings"
          title={t("page_app_settings_title")}
        >
          <TuneIcon fontSize="small" />
        </NavItemComponent> */}
      </div> 
      <Box
        className="title"
        display="flex"
        flexDirection="column"
        height="100%"
        flexWrap="wrap"
        justifyContent="flex-end"
        alignContent="center"
      >
        {config.configBrand === BRAND_NAMES.KYOCERA && (
          <img
            className="login-image d-block"
            alt="Kyocera"
            src={KyoceraLogo}
          />
        )}
        {config.configBrand === BRAND_NAMES.TA && (
          <div className="login-image d-block" style={{ height: "45px" }}></div>
        )}
      </Box>
  </SideNav>
  );
};

export default SideNavComponent;
